import { keyframes } from "@emotion/react"
import styled from "@emotion/styled"

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`

const Card = styled.div`
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.16);
  min-height: 153px;
  ${(props) => props.theme.breakpoints.up("md")} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 32px;
    box-shadow: 0px 0px 16px 0px rgba(0, 38, 83, 0.1);
    min-height: 99px;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  ${(props) => props.theme.breakpoints.up("md")} {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 32px;
  }
`

const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  ${(props) => props.theme.breakpoints.up("md")} {
    min-width: 295px;
    align-items: flex-start;
    width: auto;
  }
`

const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;

  ${(props) => props.theme.breakpoints.up("md")} {
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 40px;
    width: auto;
  }
`

const InfoItem = styled.div<{ minWidthDesktop?: number }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: 100%;

  ${(props) => props.theme.breakpoints.up("md")} {
    min-width: ${(props) => (props.minWidthDesktop ? props.minWidthDesktop + "px" : "auto")};
    width: auto;
  }
`

const Placeholder = styled.div`
  background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 37%, #f2f2f2 63%);
  background-size: 400% 100%;
  animation: ${shimmer} 1.2s ease-in-out infinite;
  border-radius: 8px;
`

const CompanyPlaceholder = styled(Placeholder)`
  height: 14px;
  width: 160px;
`

const TitlePlaceholder = styled(Placeholder)`
  height: 22px;
  width: 240px;
`

const IconPlaceholder = styled(Placeholder)`
  width: 16px;
  height: 16px;
  border-radius: 4px;
  flex-shrink: 0;
`

const InfoLine = styled(Placeholder)`
  height: 14px;
  width: 140px;
`

const Actions = styled.div`
  display: none;

  ${(props) => props.theme.breakpoints.up("md")} {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

const ButtonPlaceholder = styled(Placeholder)`
  width: 120px;
  height: 40px;
  border-radius: 8px;
`

function JobSkeleton() {
  return (
    <Card>
      <Content>
        <TitleBlock>
          <CompanyPlaceholder aria-hidden />
          <TitlePlaceholder aria-hidden />
        </TitleBlock>
        <InfoBlock>
          <InfoItem minWidthDesktop={200}>
            <IconPlaceholder aria-hidden />
            <InfoLine aria-hidden />
          </InfoItem>
          <InfoItem>
            <IconPlaceholder aria-hidden />
            <InfoLine aria-hidden />
          </InfoItem>
        </InfoBlock>
      </Content>
      <Actions>
        <ButtonPlaceholder aria-hidden />
      </Actions>
    </Card>
  )
}

export default JobSkeleton
